export default "__VITE_ASSET__0raz7OcH__"